define('views/blocks/ListingTitleView',['underscore','jquery','backbone','app','SubView','CSS3Events','template!blocks/listing/title'],
    function (_,$,Backbone,app,SubView,CSS3Events,titleTemplate) {

    //
    // Listing Title View
    // représente le bloc supérieure, contenant le titre et l'image de la catégorie en cours
    //

        var view, // vue instanciée une seule fois en même temps, sur la page Listing
            viewBg,
            currentCategory;

    return Backbone.View.extend(SubView).extend({
        events:{
            'click .burger': 'showNav'
        },
        initialize:function(){

            view = this;
            viewBg = view.$('.bg');

            view.subviews = [];
            currentCategory = false;

            view.listenTo(app,'listingCategoryChange',view.onCategoryChange);

        },

        onCategoryChange:function(id_category,direction){
            if(currentCategory === id_category) return;
            currentCategory = id_category;

            if (app.isDesktop() && !Modernizr.touchevents && app.get('winH') > 850) { // Desktop action
                requestAnimationFrame(function(){
                        var category = app.getCategory(id_category),
                        bgNewWrapper = $(titleTemplate({
                            label: category.getName(),
                            image: category.getPictureUrl(),
                            titleColor: category.getTitleColor(),
                            direction: direction ? 'bottom' : 'top'
                        }));
                    viewBg.append(bgNewWrapper);
                    // on démarre la transition
                    view.startTransition(direction, bgNewWrapper);
                });
            }
        },

        startTransition: function(direction, bgCurrent){
            //
            // la transition permet d'afficher
            // le titre de la catégorie en cours,
            // sans exiger d'arrêt de la transition en cours
            // mais en sautant celles dans la queue d'animation
            //
            var view = this,
                bgWrappers = view.$('.bg-wrapper'),
                bgFirst = bgWrappers.first(),
                bgSecond = bgWrappers.eq(1),
                bgLast = bgWrappers.last(),
                useQueue = bgSecond[0] != bgCurrent[0]; // cas plusieurs transitions simultanées, on attend

            if (!useQueue) {
                bgSecond.one(CSS3Events('transitionend'), function () {
                    bgFirst.remove(); // on supprime le bloc
                });
                requestAnimationFrame(function () {
                    bgSecond.removeClass('top bottom');
                });
            } else {
                bgWrappers.each(function(){
                    switch(this){
                        case bgFirst[0] :
                        case bgSecond[0] :
                        case bgLast[0] :
                            // on enlève tous les élements sauf le 1,2 et dernier
                            break;
                        default: $(this).remove();
                    }
                });
                bgSecond.one(CSS3Events('transitionend'), function () {
                    if (bgLast[0] == bgCurrent[0]) { // Si il est toujours le dernier, alors on l'affiche
                        view.startTransition(direction, bgLast);
                    } else { // Sinon, une autre catégorie a été scrollée depuis, donc on le supprime
                        bgCurrent.remove();
                    }
                });
            }
        },

        showNav: function(){
          app.trigger('openSideNav');
        },

        render:function(){
        },
    });
});
